import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class PlaylistService {
  playlistAction = new Subject();

  constructor(private httpClient: HttpClient) { }

  getAction(): Observable<any> {
    return this.playlistAction.asObservable();
  }

  sendAction(action, data) {
    return this.playlistAction.next({ action: action, data: data });
  }

  create(form): Observable<any> {
    let data = form;
    return this.httpClient.post('playlist', data);
  }

  update(form): Observable<any> {
    let data = form;
    return this.httpClient.patch('playlist', data);
  }

  list(filter = ""): Observable<any> {
    if (filter) {
      filter = "?" + filter;
    }
    return this.httpClient.get('playlist' + filter);
  }

  delete(playlistId): Observable<any> {
    return this.httpClient.delete('playlist/' + playlistId);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/services/playlist/playlist.service.ts